import { Controller } from "@hotwired/stimulus"

// Swaps a logo <img> for a text fallback (e.g. company initials) when the image
// fails to load. The usual cause is a blob whose file is missing from object
// storage — the row exists, the object does not — which the representation
// request answers with a 404 (config/initializers/active_storage_variant_race.rb,
// LUC-917). Rather than show a broken-image icon, we hide the <img> and reveal
// the fallback element.
export default class extends Controller {
  static targets = ["image", "fallback"]

  connect() {
    if (!this.hasImageTarget) return

    this.imageTarget.addEventListener("error", this.showFallback)

    // The image may have already failed before this controller connected
    // (e.g. a cached error). complete + zero naturalWidth means it broke.
    if (this.imageTarget.complete && this.imageTarget.naturalWidth === 0 && this.imageTarget.getAttribute("src")) {
      this.showFallback()
    }
  }

  disconnect() {
    if (this.hasImageTarget) this.imageTarget.removeEventListener("error", this.showFallback)
  }

  showFallback = () => {
    if (this.hasImageTarget) this.imageTarget.classList.add("d-none")
    if (this.hasFallbackTarget) this.fallbackTarget.classList.remove("d-none")
  }
}
